import Api from '@/services/Api'

const HEADERURL = 'wms/agenda-proveedores/';

export default {

    fetch(params) {
        return Api().get(HEADERURL, {
            params: params
        });
    },

    getById(id) {

        return Api().get(`${HEADERURL}${id}`);

    },

}